var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophySolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #ed7850;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M400,0h-224c-26.5,0-48.1,21.8-47.1,48.2.2,5.3.4,10.6.7,15.8H24c-13.3,0-24,10.7-24,24,0,92.6,33.5,157,78.5,200.7,44.3,43.1,98.3,64.8,138.1,75.8,23.4,6.5,39.4,26,39.4,45.6s-17,37.9-37.9,37.9h-26.1c-17.7,0-32,14.3-32,32s14.3,32,32,32h192c17.7,0,32-14.3,32-32s-14.3-32-32-32h-26.1c-20.9,0-37.9-17-37.9-37.9s15.9-39.2,39.4-45.6c39.9-11,93.9-32.7,138.2-75.8,44.9-43.7,78.4-108.1,78.4-200.7s-10.7-24-24-24h-105.6c.3-5.2.5-10.4.7-15.8,1-26.4-20.6-48.2-47.1-48.2ZM48.9,112h84.4c9.1,90.1,29.2,150.3,51.9,190.6-24.9-11-50.8-26.5-73.2-48.3-32-31.1-58-76-63-142.3h-.1ZM464.1,254.3c-22.4,21.8-48.3,37.3-73.2,48.3,22.7-40.3,42.8-100.5,51.9-190.6h84.4c-5.1,66.3-31.1,111.2-63,142.3h-.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophySolid);
export default __webpack_public_path__ + "static/media/trophy-solid.01365b8178f7cf7b783bbcba2f8570b9.svg";
export { ForwardRef as ReactComponent };